import { render, staticRenderFns } from "./UploadExcel.vue?vue&type=template&id=b37b0002&scoped=true&"
import script from "./UploadExcel.vue?vue&type=script&lang=js&"
export * from "./UploadExcel.vue?vue&type=script&lang=js&"
import style0 from "./UploadExcel.vue?vue&type=style&index=0&id=b37b0002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37b0002",
  null
  
)

export default component.exports